<template>
  <div
    class="tooltip"
    v-show="visible"
    ref="tooltip"
    :style="{ top: `${y}px`, left: `${x}px` }"
    :class="{ horizontal: horizontal }"
  >
    <slot></slot>
  </div>  
</template>

<script>
export default {
  name: "tooltip",
  data() {
    return { x: -1000, y: -1000, debouncedCords: null };
  },
  props: {
    visible: { type: Boolean, default: false },
    static: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
  },
  watch: {
    visible(value) {
      if (value == true) {
        window.addEventListener("mousemove", this.getCords, true);
      } else {
        window.removeEventListener("mousemove", this.getCords, true);
      }
    },
  },
  methods: {
    getCords(event) {
      this.x = event.pageX;
      this.y = event.pageY;

      if (this.$refs.tooltip && this.horizontal) {
        if (this.x * 2 < window.innerWidth) {
          this.$refs.tooltip.classList.add("right");
          this.$refs.tooltip.classList.remove("left");
        } else {
          this.$refs.tooltip.classList.add("left");
          this.$refs.tooltip.classList.remove("right");
        }
      } else if (this.$refs.tooltip) {
        if (this.y * 3 < window.innerHeight) {
          this.$refs.tooltip.classList.add("bottom");
          this.$refs.tooltip.classList.remove("top");
        } else {
          this.$refs.tooltip.classList.add("top");
          this.$refs.tooltip.classList.remove("bottom");
        }
      }

      // Debounce
      window.removeEventListener("mousemove", this.getCords, true);
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.visible == true) {
            window.addEventListener("mousemove", this.getCords, true);
          }
        });
      }, 5);
    },
  },
};

</script>

<style lang="scss">
.tooltip {
  position: fixed;
  top: -100%;
  left: -100%;

  z-index: 100;
  transform: translate(-50%, calc(-100% - 11px));

  max-width: 200px;
  width: auto;
  max-height: auto;
  min-width: 80px;
  min-height: 50px;

  padding: 16px;

  background: #fff;
  border: 1px solid $lightGray;
  border-radius: 14px;

  &.bottom {
    transform: translate(-50%, calc(11px));
  }

  &.horizontal {
    transform: translate(calc(-100% - 11px), -50%);
    &.right {
      transform: translate(calc(11px), -50%);
    }
  }
}
</style>
